// extracted by mini-css-extract-plugin
export var autoExpand = "_1g-8";
export var container = "_1g-7";
export var containerWidth = "_1g-5";
export var disabled = "_1g-2";
export var error = "_1g-3";
export var fullWidth = "_1g-6";
export var inputWrapper = "_1g-0";
export var small = "_1g-1";
export var textarea = "_1g-4";